@if (selectionMode) {
  @for (selectedFile of selectedFiles; track selectedFile) {
    <p-chip
      class="m-2"
      [label]="selectedFile.filename"
      [removable]="true"
      (onRemove)="removeSelectedFile(selectedFile.id)"
    />
  }
}

<p-fileUpload
  #fileUpload
  chooseLabel="Parcourir les fichiers"
  i18n-chooseLabel="@@file_content_list_upload_button"
  chooseIcon="pi pi-plus"
  [showCancelButton]="false"
  [showUploadButton]="false"
  [accept]="validExtensions.join(',')"
  [multiple]="true"
  [maxFileSize]="MAX_FILE_SIZE"
  [customUpload]="true"
  (uploadHandler)="onUpload($event)"
  [disabled]="uploading"
>
  <ng-template pTemplate="content">
    @if (fileUpload.files.length === 0 && !uploading) {
      <div class="justify-content-center flex">
        <div class="font-italic">
          <ng-container i18n="@@file_content_list_file_drop_info"
            >Glisser-déposer des fichiers ici (Max 20MB par fichiers)</ng-container
          >
        </div>
      </div>
    }
    @if (uploading) {
      <div class="justify-content-center flex">
        <p-progressSpinner
          styleClass="w-3rem h-3rem"
          strokeWidth="5"
        />
      </div>
    }
    <div class="justify-content-end flex mt-3">
      <p-button
        label="Transférer"
        i18n-label="@@file_content_list_upload_button_label"
        (onClick)="fileUpload.upload()"
        icon="pi pi-upload"
        severity="success"
        [disabled]="!fileUpload.files || fileUpload.files.length === 0 || this.uploading"
      />
    </div>
  </ng-template>
</p-fileUpload>

<p-sidebar
  [(visible)]="sidebarVisible"
  [appendTo]="'body'"
  styleClass="w-4"
  position="right"
>
  <h3>{{ selectedForSideBar?.filename }}</h3>
  @if (selectedForSideBarNumberOfChunks) {
    <div class="font-italic mb-3">
      <ng-container i18n="@@file_content_list_embeddings">Embeddings:</ng-container>
      {{ selectedForSideBarNumberOfChunks }}
    </div>
  }
  @if (selectedForSideBar?.content) {
    <div class="file-content">
      {{ selectedForSideBar!.content!.substring(0, 100000) }}
      {{ selectedForSideBar!.content!.length > 100000 ? "..." : "" }}
    </div>
  }
</p-sidebar>

<p-table
  [value]="fileContentList"
  [lazy]="true"
  [lazyLoadOnInit]="false"
  (onLazyLoad)="loadItems($event.first!)"
  dataKey="id"
  [paginator]="true"
  [rows]="pageSize"
  [totalRecords]="totalRecords"
  [showCurrentPageReport]="true"
  [(first)]="actualPage"
>
  <ng-template pTemplate="header">
    <tr>
      <th i18n="@@file_content_list_name_column">Nom du fichier</th>
      <th i18n="@@file_content_list_import_date_column">Date d'import</th>
      <th style="width: 5rem"></th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-fileContent
    [ngAs]="FileContent"
  >
    @if (pageLoading) {
      <tr>
        <td colspan="5">
          <div class="flex align-items-center justify-content-center mt-4">
            <p-progressSpinner
              styleClass="w-3rem h-3rem"
              strokeWidth="5"
            />
          </div>
        </td>
      </tr>
    }
    <tr
      class="clickable-row"
      (click)="selectionMode ? addSelectedFile(fileContent) : showFileContent(fileContent)"
    >
      <td>{{ fileContent.filename }}</td>
      <td>
        {{ fileContent.uploadDate | date: "dd MMMM yyyy, HH'h'mm" : "CEST" }}
      </td>
      <td>
        <div class="flex gap-3 align-items-center justify-content-center">
          @if (selectionMode) {
            <button
              class="p-button-success"
              type="button"
              pButton
              tooltipPosition="left"
              pTooltip="Ajouter"
              i18n-pTooltip="@@prompt_editor_add_button_label"
              (click)="$event.stopImmediatePropagation(); addSelectedFile(fileContent)"
            >
              <i class="pi pi-plus"></i>
            </button>
          } @else {
            <button
              class="p-button-danger"
              type="button"
              pButton
              tooltipPosition="left"
              pTooltip="Supprimer le fichier"
              i18n-pTooltip="@@file_content_list_delete_button_label"
              (click)="$event.stopImmediatePropagation(); deleteFileContent(fileContent)"
            >
              <i class="pi pi-trash"></i>
            </button>
          }
          <button
            type="button"
            pButton
            tooltipPosition="left"
            pTooltip="Afficher le contenu"
            i18n-pTooltip="@@file_content_list_show_file_tooltip"
            (click)="showFileContent(fileContent)"
          >
            <i class="pi pi-arrow-right"></i>
          </button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-confirmDialog key="positionDialog" />
